/* eslint-disable no-restricted-syntax */
import React from "react";

import { Divider, Grid, IconButton } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { Box, TextField } from "@mui/material";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import moment from "moment";
import { Close } from "@material-ui/icons";
import { CheckedRadioGroup } from "../../../../shared/components/commonComponents/CheckedRadioGroup";
import { Button, ThemeActionButton } from "../../../../shared/widgets";
import { SettlementCycle } from "./SettlementCycles";
import { CommonDropdown } from "./common";

function TextFieldComponent(props) {
  return (
    <TextField
      {...props}
      inputProps={{
        readOnly: Boolean(true),
      }}
    />
  );
}

const settlementTypes = {
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
};

const isDisabled = (configData) => {
  let disable = true;
  if (
    configData?.settlementCycleData?.length
  ) {
    for (const element of configData.settlementCycleData) {
      const currentCycle = element.settlementCycle;
      if (
        currentCycle === "Monthly"
        && (element.settlementCutoffDate
          && element.settlementRunDate)
      ) {
        disable = false;
        break;
      }
      if (
        currentCycle === "Weekly"
        && (element.settlementCutoffDay
          && element.settlementRunDay)
      ) {
        disable = false;
        break;
      }
      if (
        currentCycle === "Daily"
      ) {
        disable = false;
        break;
      }
    }
  }
  return disable;
};

function SettlementConfig(props) {
  const {
    configData, onChangeHandler, handleOnClick,
    errorStatus, onCloseCyclehandler, addSettlementHandler,
  } = props;

  const commonHandler = ({ handlerProps, index }) => onChangeHandler({
    target: handlerProps.target,
    cycleData: true,
    index,
  });

  return (
    <Box padding={3}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container direction="column" spacing={4}>
          <Grid container item alignItems="flex-end" spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ fontWeight: "bold" }}>Settlement Start Date</Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3} className="customConfigWrapper">
              <KeyboardDatePicker
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                    paddingRight: 0,
                    "&.Mui-focused fieldset, &:hover": {
                      borderWidth: "0 0 2px 0",
                      borderColor: "black",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "8px 0 8px 0px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderWidth: "0 0 1px 0",
                  },
                  "& .MuiSvgIcon-root": {
                    fill: "black",
                  },
                }}
                variant="standard"
                format="dd/MM/yyyy"
                autoOk
                animateYearScrolling
                name="settlementStartDate"
                margin="normal"
                value={configData.settlementStartDate}
                onChange={(date) => onChangeHandler({
                  target: {
                    name: "settlementStartDate",
                    value: moment(date).set({
                      hour: 0,
                      minute: 0,
                      second: 0,
                      millisecond: 0,
                    }),
                  },
                })}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                TextFieldComponent={TextFieldComponent}
              />
            </Grid>
          </Grid>

          <Grid container item alignItems="flex-end">
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ fontWeight: "bold" }}>
                Include Money Loaded
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CheckedRadioGroup
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
                defaultValue={configData.includeMoneyLoaded}
                onChangeHandler={onChangeHandler}
                name="includeMoneyLoaded"
              />
            </Grid>
          </Grid>

          {configData.settlementCycleData?.map((value, index) => {
            const updatedSettlementTypes = Object.keys(settlementTypes).filter((option) => {
              const isOptionIncluded = configData.settlementCycleData.some(
                (item) => item.settlementCycle === option,
              );
              const isOptionSameAsCurrent = option === value.settlementCycle;
              return !isOptionIncluded || isOptionSameAsCurrent;
            });
            return (
              <>
                <Divider
                  style={{
                    marginBottom: 10,
                  }}
                />

                <Grid container item alignItems="flex-end" spacing={3}>
                  <Grid item xs={11} sm={6} md={3}>
                    <Box sx={{ fontWeight: "bold" }}>Settlement Cycle</Box>
                  </Grid>
                  <Grid item xs={11} sm={5} md={3}>
                    <CommonDropdown
                      required
                      options={
                        updatedSettlementTypes.map(
                          (item) => ({
                            value: item,
                            label: item.charAt(0).toUpperCase() + item.slice(1),
                          }),
                        )
                      }
                      onChangeHandler={(handlerProps) => commonHandler({ handlerProps, index })}
                      selectedValue={
                        configData.settlementCycleData[index].settlementCycle
                      }
                      inputLabel="Settlement Cycle"
                      name="settlementCycle"
                    />
                  </Grid>
                  {configData.settlementCycleData[index].isAdd && (
                    <Grid item style={{ position: "absolute", right: "10px" }}>
                      <IconButton
                        onClick={() => onCloseCyclehandler(index)}
                        sx={{
                          color: "black",
                        }}
                      >
                        <Close />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>

                {configData.settlementCycleData[index].settlementCycle
                  && (configData.settlementCycleData[index].settlementCycle
                    === "Monthly"
                    || configData.settlementCycleData[index].settlementCycle
                      === "Weekly")
                      && (
                        <Grid container item alignItems="flex-end" spacing={3}>
                          <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{ fontWeight: "bold" }}>WayBill Start Offset</Box>
                          </Grid>
                          <Grid item xs={12} sm={5} md={3}>
                            <CommonDropdown
                              required
                              options={[...Array(3)].map((_, i) => ({
                                label: `T-${i}`,
                                value: `${i}`,
                              }))}
                              onChangeHandler={(handlerProps) => commonHandler(
                                { handlerProps, index },
                              )}
                              selectedValue={
                                configData.settlementCycleData[index].offSetDate
                              }
                              inputLabel="Off Set Date"
                              name="offSetDate"
                            />
                          </Grid>
                        </Grid>
                      )}

                {configData.settlementCycleData[index].settlementCycle && (
                  <SettlementCycle
                    configData={configData.settlementCycleData[index]}
                    onChangeHandler={(handlerProps) => commonHandler({ handlerProps, index })}
                    errorStatus={errorStatus}
                  />
                )}
              </>
            );
          })}

          <Grid container item>
            <Grid className="add-settlement-button" item>
              <ThemeActionButton
                buttonText="Add Settlement Cycle"
                onClick={() => addSettlementHandler()}
              />
            </Grid>
          </Grid>

          <Divider
            style={{
              marginBottom: 10,
            }}
          />
          <Grid container item>
            <Grid className="config-form-button" item>
              <Button
                buttonText="Update Configuration"
                onClick={() => handleOnClick("settlements")}
                disable={isDisabled(configData)}
              />
            </Grid>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Box>
  );
}

export default SettlementConfig;
